import React, { useState } from 'react';
import BrandMark from '../components/BrandMark';
import './AdminPage.css';

const workspaces = [
  { id: 'map', label: '模块地图', desc: '梳理网站后台管理范围', icon: 'grid' },
  { id: 'learning', label: '交易学习', desc: '教程、书籍、学习路径、首页成长版', icon: 'book' },
  { id: 'member', label: '会员与返佣', desc: '用户、UID、邀请码、交易所返佣', icon: 'link', badge: '优先' },
  { id: 'operations', label: '运营发布', desc: '空投、动态、站内信、公告', icon: 'send' },
  { id: 'market', label: '行情与工具', desc: '热力图、币种、美股、机构持仓、工具入口', icon: 'chart' },
  { id: 'system', label: '系统配置', desc: '素材、权限、导航、展示开关', icon: 'settings' },
];

const websiteScope = [
  {
    title: '交易学习',
    source: 'docs.js + newbie_guides',
    count: '17 篇静态文档 / 3 类内容',
    items: ['交易所教程', '推荐书籍', '财富认知', '从0到1学习路径'],
    priority: 'P0',
  },
  {
    title: '会员与返佣',
    source: 'users + rebateData',
    count: '3 个交易所 / UID 绑定 / 邀请码',
    items: ['Binance / OKX / Bitget', 'YL188 邀请码', '用户 UID 核验', '专业版状态'],
    priority: 'P0',
  },
  {
    title: '运营发布',
    source: 'airdrops + social_posts',
    count: '空投活动 / 社区动态',
    items: ['活动时间', '奖励说明', '动态图文', '外部来源链接'],
    priority: 'P1',
  },
  {
    title: '行情与工具',
    source: 'CoinGecko / Yahoo / SEC + 工具路由',
    count: '热力图、币种详情、美股详情、13F',
    items: ['币种白名单', '美股观察列表', '机构清单', '工具入口权限'],
    priority: 'P1',
  },
  {
    title: '系统配置',
    source: '站点配置 + 图片素材',
    count: 'Logo、首页素材、导航、权限',
    items: ['首页展示顺序', '书籍封面', '底部链接', '后台角色'],
    priority: 'P2',
  },
];

const priorities = [
  ['P0', '核心管理', '文章/书籍管理、用户 UID 核验、交易所返佣配置'],
  ['P1', '运营管理', '空投活动、社区动态、行情白名单、工具权限'],
  ['P2', '系统配置', '素材库、首页模块排序、系统角色、操作日志'],
];

const workspaceDetails = {
  learning: {
    title: '交易学习工作台',
    desc: '覆盖教程列表、书籍推荐、成长版学习路径和文档详情页底部返佣入口。',
    cards: [
      ['教程内容库', '管理 交易所教程 / 财富认知 / 新手教学，支持草稿、发布、排序。'],
      ['书籍与封面', '维护首页 3 本推荐书籍、封面图、作者和推荐理由。'],
      ['学习路径配置', '调整从0到1学交易的阶段、按钮跳转和首页展示文案。'],
    ],
    tableHead: ['后台对象', '关联页面', '建议字段', '优先级'],
    rows: [
      ['交易所教程', '/docs', '标题、分类、正文、封面、排序、状态', 'P0'],
      ['推荐书籍', '首页 + /docs', '书名、作者、封面、摘要、详情内容', 'P0'],
      ['学习路径', '首页成长版', '阶段名、说明、跳转、展示开关', 'P1'],
    ],
  },
  member: {
    title: '会员与返佣工作台',
    desc: '这是最应该优先后台化的部分，直接关系注册转化、UID 绑定和返佣确认。',
    cards: [
      ['交易所返佣配置', '维护 Binance、OKX、Bitget 的返佣比例、注册链接、教程入口和费率说明。'],
      ['用户 UID 核验', '查看用户提交的 Binance / OKX / Bitget UID，标记已核验、异常或待补充。'],
      ['注册链接与邀请码', '统一管理 YL188、平台链接、注册按钮和文档底部返佣入口。'],
    ],
    tableHead: ['后台对象', '关联页面', '建议字段', '优先级'],
    rows: [
      ['交易所卡片', '/rebate', '名称、Logo、返佣比例、标签、注册链接', 'P0'],
      ['返佣详情页', '/rebate/:exchange', '优势、换绑说明、注册步骤、FAQ', 'P0'],
      ['用户资料', '/profile', '会员类型、UID、微信、邀请码、核验状态', 'P0'],
      ['邀请链路', '/register + 文档底部', '父级邀请码、来源页面、注册状态', 'P1'],
    ],
  },
  operations: {
    title: '运营发布工作台',
    desc: '让你不用改代码也能发布空投、社区动态和站内运营消息。',
    cards: [
      ['空投活动', '维护活动状态、奖励、开始/结束时间、详情链接。'],
      ['社区动态', '发布图文动态，管理外部来源链接和首页预览。'],
      ['站内消息', '发送会员开通提醒、UID 补充、活动通知。'],
    ],
    tableHead: ['后台对象', '数据来源', '建议字段', '优先级'],
    rows: [
      ['空投活动', 'airdrops', '名称、奖励、描述、时间、状态、链接', 'P1'],
      ['社区动态', 'social_posts', '正文、图片组、来源链接、发布时间', 'P1'],
      ['站内信', '消息表', '收件用户、消息类型、处理状态', 'P2'],
    ],
  },
  market: {
    title: '行情与工具工作台',
    desc: '行情数据来自外部 API，后台用于管理白名单、展示顺序、fallback 和工具权限。',
    cards: [
      ['行情白名单', '配置首页市场卡、完整热力图、币种详情页展示资产。'],
      ['美股与机构', '维护 NVDA、MSTR、COIN 等股票清单和 13F 机构列表。'],
      ['工具入口权限', '管理 K线匹配、出货侦探、支撑压力位的入口、状态和会员可见性。'],
    ],
    tableHead: ['后台对象', '关联页面', '建议字段', '优先级'],
    rows: [
      ['币种与热力图', '/market-heatmap / /crypto/:symbol', 'CoinGecko ID、分组、权重、fallback', 'P1'],
      ['美股详情', '/stock/:ticker', 'Ticker、名称、Logo、SEC CIK、展示状态', 'P1'],
      ['机构持仓', '/institution/:cik', '机构名、CIK、短名、排序、fallback', 'P1'],
      ['工具权限', '/tools + 专业版首页', '工具名、说明、状态、会员等级、排序', 'P0'],
    ],
  },
  system: {
    title: '系统配置工作台',
    desc: '管理站点素材、导航配置、展示开关和后台权限。',
    cards: [
      ['素材库', '管理 Logo、首页背景、书籍封面、教程截图。'],
      ['首页模块', '控制成长版/专业版模块展示顺序、开关和 CTA 文案。'],
      ['权限与日志', '管理管理员角色、操作记录、发布回滚。'],
    ],
    tableHead: ['后台对象', '范围', '建议字段', '优先级'],
    rows: [
      ['图片素材', 'public/images', '用途、文件、替换历史、尺寸', 'P2'],
      ['导航配置', 'GlobalNav + Footer', '菜单、跳转、展示开关', 'P2'],
      ['后台角色', 'Admin', 'Owner、Editor、Support、只读权限', 'P2'],
    ],
  },
};

function AdminIcon({ type }) {
  const paths = {
    grid: 'M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M13 13h7v7h-7z',
    book: 'M5 4h10a4 4 0 014 4v12H9a4 4 0 00-4-4z M5 4v16',
    link: 'M10 7H8a5 5 0 000 10h2m4-10h2a5 5 0 010 10h-2M8 12h8',
    send: 'M4 12l16-8-4 16-4-6-8-2z',
    chart: 'M4 19V9m8 10V5m8 14v-7',
    settings: 'M12 8a4 4 0 100 8 4 4 0 000-8z M4 12h2m12 0h2M12 4v2m0 12v2',
  };

  return (
    <svg className="admin-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d={paths[type]} />
    </svg>
  );
}

function PriorityPill({ value }) {
  return <span className={`admin-priority admin-priority-${value.toLowerCase()}`}>{value}</span>;
}

function ModuleMap({ setActiveWorkspace }) {
  return (
    <>
      <section className="admin-scope-grid" aria-label="网站后台化范围">
        {websiteScope.map((scope) => (
          <article className="admin-scope-card" key={scope.title}>
            <div className="admin-scope-top">
              <h2>{scope.title}</h2>
              <PriorityPill value={scope.priority} />
            </div>
            <p className="admin-scope-source">{scope.source}</p>
            <strong>{scope.count}</strong>
            <div className="admin-chip-row">
              {scope.items.map((item) => <span key={item}>{item}</span>)}
            </div>
          </article>
        ))}
      </section>

      <section className="admin-priority-panel">
        <div className="admin-panel-head">
          <div>
            <h2>开通后台管理优先级</h2>
            <p>按照网站业务价值排序，聚焦能减少手工改代码、影响转化和会员服务的部分。</p>
          </div>
          <button type="button" className="admin-btn-primary" onClick={() => setActiveWorkspace('member')}>
            查看会员与返佣
          </button>
        </div>
        <div className="admin-priority-list">
          {priorities.map(([level, label, text]) => (
            <div key={level}>
              <PriorityPill value={level} />
              <strong>{label}</strong>
              <span>{text}</span>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

function Workspace({ workspace }) {
  const detail = workspaceDetails[workspace];

  return (
    <>
      <section className="admin-workspace-cards">
        {detail.cards.map(([title, desc]) => (
          <article className="admin-work-card" key={title}>
            <h2>{title}</h2>
            <p>{desc}</p>
          </article>
        ))}
      </section>

      <section className="admin-table-card">
        <div className="admin-table-toolbar">
          <div>
            <div className="admin-table-title">后台对象拆分</div>
            <div className="admin-table-subtitle">展示后台对象、字段范围和管理优先级。</div>
          </div>
          <div className="admin-actions">
            <button type="button" className="admin-btn">预览</button>
            <button type="button" className="admin-btn admin-btn-primary">字段配置</button>
          </div>
        </div>
        <table className="admin-table">
          <thead>
            <tr>
              {detail.tableHead.map((head) => <th key={head}>{head}</th>)}
            </tr>
          </thead>
          <tbody>
            {detail.rows.map((row) => (
              <tr key={row.join('-')}>
                {row.map((cell, index) => (
                  <td key={`${cell}-${index}`}>
                    {String(cell).startsWith('P') ? <PriorityPill value={cell} /> : cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </>
  );
}

function AdminPage() {
  const [activeWorkspace, setActiveWorkspace] = useState('map');
  const active = workspaces.find((item) => item.id === activeWorkspace);
  const detail = activeWorkspace === 'map'
    ? {
      title: '后台模块地图',
      desc: '基于网站页面和数据来源，梳理需要后台管理的内容范围。',
      eyebrow: 'Admin Blueprint',
    }
    : {
      title: workspaceDetails[activeWorkspace].title,
      desc: workspaceDetails[activeWorkspace].desc,
      eyebrow: active.label,
    };

  return (
    <div className="admin-page-shell">
      <header className="admin-topbar">
        <div className="admin-brand">
          <BrandMark className="admin-brand-mark" alt="GHOST" />
          <div>
            <div className="admin-brand-name">GHOST 管理后台</div>
            <div className="admin-brand-subtitle">游领社区配置中心</div>
          </div>
        </div>
        <div className="admin-topbar-actions">
          <span className="admin-env-badge">Admin</span>
          <span className="admin-operator">配置管理</span>
        </div>
      </header>

      <aside className="admin-sidebar">
        <div className="admin-nav-label">后台分区</div>
        {workspaces.map((workspace) => (
          <button
            type="button"
            key={workspace.id}
            className={`admin-nav-item${activeWorkspace === workspace.id ? ' active' : ''}`}
            onClick={() => setActiveWorkspace(workspace.id)}
          >
            <AdminIcon type={workspace.icon} />
            <span>
              <strong>{workspace.label}</strong>
              <em>{workspace.desc}</em>
            </span>
            {workspace.badge && <span className="admin-nav-badge">{workspace.badge}</span>}
          </button>
        ))}
      </aside>

      <main className="admin-main">
        <section className="admin-hero">
          <div>
            <div className="admin-eyebrow">{detail.eyebrow}</div>
            <h1>{detail.title}</h1>
            <p>{detail.desc}</p>
          </div>
          <div className="admin-prototype-note">管理总览</div>
        </section>

        {activeWorkspace === 'map' ? (
          <ModuleMap setActiveWorkspace={setActiveWorkspace} />
        ) : (
          <Workspace workspace={activeWorkspace} />
        )}
      </main>
    </div>
  );
}

export default AdminPage;
